module.exports = __webpack_public_path__ + "static/media/facts-img.0bca5398.png";